import { TemplateRef } from '@angular/core';

import { createAction, props } from '@ngrx/store';

import { BetslipGroupInformation } from '../../core/groups/betslip-group-information';
import { BaseBetslipGroupPick } from '../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../core/picks/betslip-pick';
import { GroupEnabledPickIds, GroupPickId, PickId } from '../../core/picks/pick-id';
import { IPickTracking } from '../../core/picks/pick-models';
import { ReplacePickPayload } from './replace-pick-payload';

const groupedType = '@betslip/group-pick/';
interface GroupActionBasePayload {
    groupInfo: BetslipGroupInformation;
}
//This will indicate that this pick that should be added to a group (could be new group/could be existing group, hence "request add")
export const requestAddPickToGroup = createAction(
    `${groupedType}REQUEST_ADD_PICK_TO_GROUP`,
    props<
        {
            pickId: GroupEnabledPickIds;
            removePick?: boolean;
            tracking: IPickTracking;
            sportId?: number;
            priceId?: number;
            //maintain for single betslip type
            isPriceBoosted?: boolean;
            isBetBuilderEnabled: boolean;
        } & GroupActionBasePayload
    >(),
);

export const requestAddGroup = createAction(
    `${groupedType}REQUEST_ADD_GROUP`,
    props<
        {
            picksIds: GroupEnabledPickIds[];
            removePicks?: boolean;
            tracking: IPickTracking;
            sportId?: number;
            priceId?: number;
            //maintain for single betslip type
            isPriceBoosted?: boolean;
            isBetBuilderEnabled?: boolean;
            headerTemplate?: TemplateRef<any>;
        } & GroupActionBasePayload
    >(),
);

export const subscribeToPicksGroup = createAction(
    `${groupedType}SUBSCRIBE_TO_PICKS_GROUP`,
    props<
        {
            SGPId: string;
        } & GroupActionBasePayload
    >(),
);

export const removePicksFromGroup = createAction(
    `${groupedType}REMOVE_PICKS_FROM_GROUP`,
    props<
        {
            pickIds: GroupEnabledPickIds[];
        } & GroupActionBasePayload
    >(),
);

//This action is a high level replace pick action, it is specific to the scenario of replacing a group pick with a new group pick.
export const replaceGroup = createAction(
    `${groupedType}REPLACE_GROUP`,
    props<Omit<ReplacePickPayload, 'newPick'> & { newPick: BaseBetslipGroupPick; headerTemplate?: TemplateRef<any> }>(),
);

//This action is specific to the scenario of adding a new group pick.
export const addGroup = createAction(`${groupedType}ADD_GROUP`, props<{ newPick: BaseBetslipGroupPick; headerTemplate?: TemplateRef<any> }>());

//This action is a high level replace pick action, it is specific to the scenario of replacing a group pick with a normal pick.
export const removeAndReplaceGroup = createAction(
    `${groupedType}REMOVE_AND_REPLACE_GROUP`,
    props<Omit<ReplacePickPayload, 'pickId'> & { pickId: GroupPickId; headerTemplate?: TemplateRef<any> }>(),
);

export const addLegSubscription = createAction(
    `${groupedType}ADD_LEG_SUBSCRIPTION`,
    props<{ subscriptionContext: string[]; pickId: PickId; fromHybridFixture?: boolean }>(),
);

export const requestNavigateToBABTab = createAction(
    `${groupedType}REQUEST_NAVIGATE_TO_BAB_TAB `,
    props<{ pick: BetslipPick; headerTemplate?: TemplateRef<any> }>(),
);
